import React from "react";

import './pagePayment.css'
import logoWhite from '../../image/logo/logoWhite.svg'


const TopBarPayment = () => {
    return (
        <div className="topBarPayment">
            <div className="containerLogo">
                <img className="logoTopBar" src={logoWhite} loading="lazy" alt="logo"/>
            </div>
        </div>
    )
}
export default TopBarPayment